import { useEffect, useState } from "react";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import {
  EVENT_TYPES,
  SUBJECT_OPTIONS,
  DEFAULT_FILTERS,
  API_STATUS_OPTIONS,
} from "../constants";
import "./complaintManagement.css";

const ComplaintFilters = ({ filters, onApply, onReset }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const updateField = (field, value) => {
    setLocalFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleApply = () => onApply(localFilters);

  const handleReset = () => {
    setLocalFilters(DEFAULT_FILTERS);
    onReset();
  };

  return (
    <div className="cmp-filters">
      <div className="cmp-filters-grid">
        <div className="cmp-filter-field">
          <label>Search Order ID</label>
          <input
            type="text"
            placeholder="Order ID"
            value={localFilters.orderId}
            onChange={(e) => updateField("orderId", e.target.value)}
          />
        </div>
        <div className="cmp-filter-field">
          <label>Search Event ID</label>
          <input
            type="text"
            placeholder="Event ID"
            value={localFilters.eventId}
            onChange={(e) => updateField("eventId", e.target.value)}
          />
        </div>
        <div className="cmp-filter-field">
          <label>Event Type</label>
          <select
            value={localFilters.eventType}
            onChange={(e) => updateField("eventType", e.target.value)}
          >
            <option value="">All Types</option>
            <option value={EVENT_TYPES.CUSTOMER_SERVICE}>
              Customer Service
            </option>
            <option value={EVENT_TYPES.PENALTY}>Penalty</option>
          </select>
        </div>
        <div className="cmp-filter-field">
          <label>Status</label>
          <select
            value={localFilters.status}
            onChange={(e) => updateField("status", e.target.value)}
          >
            <option value="">All Statuses</option>
            {API_STATUS_OPTIONS.map((s) => (
              <option key={s.value} value={s.value}>
                {s.label}
              </option>
            ))}
          </select>
        </div>
        <div className="cmp-filter-field">
          <label>Subject</label>
          <select
            value={localFilters.subject}
            onChange={(e) => updateField("subject", e.target.value)}
          >
            <option value="">All Subjects</option>
            {SUBJECT_OPTIONS.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>
        <div className="cmp-filter-field">
          <label>Date From</label>
          <input
            type="date"
            value={localFilters.dateFrom}
            onChange={(e) => updateField("dateFrom", e.target.value)}
          />
        </div>
        <div className="cmp-filter-field">
          <label>Date To</label>
          <input
            type="date"
            value={localFilters.dateTo}
            onChange={(e) => updateField("dateTo", e.target.value)}
          />
        </div>
      </div>
      <div className="cmp-filters-actions">
        <MOButtonV2
          text="Apply"
          textColor="#ffffff"
          backgroundColor="#29AEE6"
          height={32}
          fontSize={12}
          padding="6px 24px"
          radius={4}
          onClick={handleApply}
        />
        <MOButtonV2
          text="Reset"
          textColor="#374151"
          backgroundColor="#F3F4F6"
          height={32}
          fontSize={12}
          padding="6px 24px"
          radius={4}
          onClick={handleReset}
        />
      </div>
    </div>
  );
};

export default ComplaintFilters;
